import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-address-label-position-dialog',
  templateUrl: './address-label-position-dialog.component.html',
  styleUrls: ['./address-label-position-dialog.component.less'],
})

export class AddressLabelPositionDialogComponent {

  // シール1面（12面）のセル番号（0〜11）
  public cells = Array.from({ length: 12 }, (_, i) => i);

  // 選択中の開始位置（初期値は1番目）
  public selectedIndex: number = 0;

  constructor(private dialogRef: MatDialogRef<AddressLabelPositionDialogComponent>) { }

  /**
   * セル選択
   * @param index 選択したセル番号
   */
  select(index: number) {
    this.selectedIndex = index;
  }

  /**
   * 決定 クリック
   */
  decide() {
    this.dialogRef.close(this.selectedIndex);
  }

  /**
   * キャンセル クリック
   */
  cancel() {
    this.dialogRef.close(null);
  }
}
